var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.502 15.998V8.002A2 2 0 0 1 11.503 6h9.235v-.998A1.994 1.994 0 0 0 18.755 3H4.313C3.202 3 2.25 3.867 2.25 4.969V19.03c0 1.102.952 1.969 2.063 1.969H18.75a1.99 1.99 0 0 0 1.983-2.002V18h-9.235a2 2 0 0 1-1.996-2.002Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.484 8.719v6.562c0 .413.338.75.75.75H21c.413 0 .75-.337.75-.75V8.72a.752.752 0 0 0-.75-.75h-8.766a.752.752 0 0 0-.75.75Zm3.614 4.776a1.5 1.5 0 0 1-1.593-1.593 1.511 1.511 0 0 1 1.401-1.402 1.5 1.5 0 0 1 1.594 1.594 1.511 1.511 0 0 1-1.402 1.401Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.edecbb00.svg";
export { ForwardRef as ReactComponent };